<template>
  <v-card class="pa-4 mt-6">
    <v-card-title class="pa-0 mb-3">
      Opis wniosku
    </v-card-title>
    <v-textarea
      v-model="description"
      outlined
      :readonly="!request.editable || isProcessing"
      hide-details
    />
    <v-btn
      v-if="request.editable"
      class="mt-4"
      color="primary"
      depressed
      :loading="isProcessing"
      @click="save"
    >
      Zapisz uzupełnienie
    </v-btn>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      description: '',
    };
  },
  computed: {
    ...mapState('dkoCooperation', ['isProcessing']),
  },
  watch: {
    request: {
      immediate: true,
      handler(request) {
        this.description = request?.description || '';
      },
    },
  },
  methods: {
    ...mapActions('dkoCooperation', ['updateRequest']),
    save() {
      this.updateRequest({ description: this.description });
    },
  },
};
</script>
